import InstagramLogo from './InstagramLogo';

export default InstagramLogo;
